import { ATTENDEE_TYPE } from '@constants/attendee';
import { useGetPath } from '@hooks/interview/useGetPath';
import { useInterviewAPI } from '@hooks/interview/useInterviewAPI';
import { useInterviewSession } from '@hooks/interview/useInterviewSession';

export function useRestart() {
  const { attendeeType } = useGetPath();
  const { getInterviewInfo } = useInterviewSession();
  const { leaveAttendeeInterview, leaveManagerInterview } = useInterviewAPI();

  const executeRestart = async () => {
    const { certificationCode, valuerSn } = getInterviewInfo();

    if (certificationCode && valuerSn) {
      switch (attendeeType) {
        case ATTENDEE_TYPE.INTERVIEWER:
          await leaveManagerInterview({ certificationCode, valuerSn });
          window.location.reload();
          break;

        default:
          await leaveAttendeeInterview({ certificationCode, valuerSn });
          window.location.reload();
          break;
      }
    }
  };

  return { executeRestart };
}
